/**
 *
 * @module entry
 * @desc {SDK.Drm} entry point.
 *
 */

import DrmManager from './drmManager';
import DrmProvider from './drmProvider';
import AtvFairPlayDrmProvider from './atvFairPlayDrmProvider';
import FairPlayDrmProvider from './fairPlayDrmProvider';
import PlayReadyDrmProvider from './playReadyDrmProvider';
import SilkDrmProvider from './silkDrmProvider';
import WidevineDrmProvider from './widevineDrmProvider';
import CertificateStorage from './certificateStorage';
import WidevineCertificateStorage from './widevineCertificateStorage';
import AtvFairPlayCertificateStorage from './atvFairPlayCertificateStorage';
import FairPlayCertificateStorage from './fairPlayCertificateStorage';

/**
 *
 * @typedef SDK.Drm
 * @type {Object}
 *
 * @property {DrmManager} DrmManager
 * @property {DrmProvider} DrmProvider
 * @property {AtvFairPlayDrmProvider} AtvFairPlayDrmProvider
 * @property {FairPlayDrmProvider} FairPlayDrmProvider
 * @property {PlayReadyDrmProvider} PlayReadyDrmProvider
 * @property {SilkDrmProvider} SilkDrmProvider
 * @property {WidevineDrmProvider} WidevineDrmProvider
 * @property {CertificateStorage} CertificateStorage
 * @property {WidevineCertificateStorage} WidevineCertificateStorage
 * @property {AtvFairPlayCertificateStorage} AtvFairPlayCertificateStorage
 * @property {FairPlayCertificateStorage} FairPlayCertificateStorage
 *
 */

/**
 *
 * @type {SDK.Drm}
 *
 */
export default {

    DrmManager,
    DrmProvider,
    AtvFairPlayDrmProvider,
    FairPlayDrmProvider,
    PlayReadyDrmProvider,
    SilkDrmProvider,
    WidevineDrmProvider,
    CertificateStorage,
    WidevineCertificateStorage,
    AtvFairPlayCertificateStorage,
    FairPlayCertificateStorage

};



// WEBPACK FOOTER //
// ./src/drm/entry.js